import { ShieldCheck, FileSignature, ClipboardCheck, Lock, FileText, Mail } from "lucide-react";

const BADGES = [
  { icon: ShieldCheck, t: "Dispositif loi retraite 2023", s: "Géré par la CARSAT — vérifiable sur ameli.fr" },
  { icon: FileSignature, t: "Engagement contractuel signé", s: "Aucune facture avant encaissement de l'aide" },
  { icon: ClipboardCheck, t: "Suivi jusqu'à décision", s: "Relances et échanges formalisés avec la caisse pendant l'instruction" },
  { icon: Lock, t: "Documents conformes CARSAT", s: "Montage des pièces selon les listes et exigences administratives" },
  { icon: FileText, t: "Mission administrative", s: "Constitution, dépôt et suivi du dossier — sans conseil technique ou terrain" },
  { icon: Mail, t: "Courriers et délais", s: "Pilotage des envois et des relances auprès de votre caisse régionale" },
];

export default function TrustBadges() {
  return (
    <section id="confiance" className="pc-bg">
      <div className="mx-auto max-w-6xl px-5 lg:px-8 py-24 lg:py-32">
        <div className="max-w-2xl">
          <div className="flex items-center gap-3 mb-5">
            <span className="tricolor-stripe !h-2.5" aria-hidden />
            <span className="text-[11.5px] tracking-[0.18em] uppercase pc-text-muted font-semibold">Garanties</span>
          </div>
          <h2 className="display-2 pc-text-ink text-balance" data-testid="trust-h2">
            Un cadre officiel.
            <span className="block pc-text-muted font-serif-emph mt-1">Des garanties signées.</span>
          </h2>
        </div>

        <div className="mt-16 grid sm:grid-cols-2 lg:grid-cols-3 gap-5 lg:gap-6">
          {BADGES.map((b, i) => {
            const Icon = b.icon;
            return (
              <div
                key={b.t}
                className="card-surface p-7 lg:p-8 flex h-full flex-col transition-colors hover:border-[var(--pc-line-strong)]"
                data-testid={`trust-badge-${i}`}
              >
                <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-[var(--pc-blue-soft)]">
                  <Icon className="h-5 w-5 pc-text-blue" strokeWidth={2} />
                </div>
                <div className="mt-7">
                  <div className="text-[17px] font-semibold leading-snug tracking-[-0.015em] pc-text-ink">{b.t}</div>
                  <div className="mt-2 text-[14px] leading-[1.55] pc-text-muted">{b.s}</div>
                </div>
              </div>
            );
          })}
        </div>

        <div className="mt-10 flex flex-wrap gap-2 justify-center sm:justify-start">
          {["Officiel CARSAT", "Payable après encaissement", "Dossier 100% géré", "Conforme ameli.fr"].map((c) => (
            <span
              key={c}
              className="inline-flex items-center gap-2 px-3.5 py-2 rounded-full bg-white border pc-line text-[13px] font-medium pc-text-ink"
              data-testid={`trust-chip-${c}`}
            >
              <span className="w-1.5 h-1.5 rounded-full bg-[var(--pc-blue)]" />
              {c}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
